import { render } from "./CreateSiteStep4.vue?vue&type=template&id=127f4553&scoped=true"
import script from "./CreateSiteStep4.vue?vue&type=script&lang=js"
export * from "./CreateSiteStep4.vue?vue&type=script&lang=js"

import "./CreateSiteStep4.vue?vue&type=style&index=0&id=127f4553&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-127f4553"]])

export default __exports__